import _ from 'lodash'
import classNames from 'classnames'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import engine from '../../../actions/engine'

class Form extends Component {
  constructor (props) {
    super(props)
    this.getAgesFields = this.getAgesFields.bind(this)
  }

  componentDidMount () {
    this.props.initializeEngine()
  }

  componentDidUpdate (prevProps) {
    // This allows the form to submit when all fields are valid
    this.props.isValidForSubmission && this.searchForm.submit()
  }

  getAgesFields () {
    // Add childAges else use partyComp counts
    const ages = this.props.partyComp.reduce((acc, curr) => {
      if (curr.key === 'children') {
        this.props.childAges.forEach(age => {
          acc.push(age.value)
        })
      } else {
        for (let i = 0; i < curr.count; i++) {
          acc.push(curr.age)
        }
      }
      return acc
    }, [])

    return ages.map((age, i) => {
      return <input key={i} type='hidden' name='ages[]' value={age} />
    })
  }

  render () {
    return (
      <form
        onSubmit={this.props.validate}
        className={classNames({
          'searchform': true,
          'searchform-inline': this.props.inline
        }, this.props.className)}
        action={this.props.action}
        method='get'
        ref={form => { this.searchForm = form }}
      >
        {this.getAgesFields()}
        <input name='customerCode' type='hidden' value={this.props.customerCode} />
        <input name='searchFormId' type='hidden' value={this.props.searchFormId} />

        <input name='roomRates[checkinDate]' type='hidden' value={moment(this.props.checkInDate).format('YYYY-MM-DD')} />
        <input name='roomRates[checkoutDate]' type='hidden' value={moment(this.props.checkOutDate).format('YYYY-MM-DD')} />

        {this.props.rooms && this.props.rooms.map((room, i) => {
          if (!room) return null
          return (
            <div key={`room_${i}`}>
              <input name={`roomRates[rooms][${i}][adults]`} type='hidden' value={room.partyComposition.adults} />
              <input name={`roomRates[rooms][${i}][children]`} type='hidden' value={room.partyComposition.children || 0} />
              <input name={`roomRates[rooms][${i}][infants]`} type='hidden' value={room.partyComposition.infants || 0} />
              <input name={`roomRates[rooms][${i}][occupancyType]`} type='hidden' value={room.occupancyType} />
            </div>
          )
        })}

        {this.props.packageGroupId &&
          <input name='packageGroupId' type='hidden' value={this.props.packageGroupId} />
        }
        <input name='context[hotelProducts][checkinDate]' type='hidden' value={moment(this.props.hotelDate).format('YYYY-MM-DD')} />

        <input name='ticketRates[startDate]' type='hidden' value={moment(this.props.checkInDate).format('YYYY-MM-DD')} />

        <input name='venueCode' type='hidden' value={this.props.venueCode} />

        {this.props.children}

        {!this.props.submitOnChange && (
          <div className='searchform-submit'>
            <div className='form-group'>
              <span>&nbsp;</span>
              <button className='btn btn-primary'>{this.props.labelSubmit}</button>
            </div>
          </div>
        )}
      </form>
    )
  }
}

Form.defaultProps = {
  action: 'availability',
  inline: false,
  labelSubmit: 'Search',
  operator: '',
  submitOnChange: false
}

function mapStateToProps (state) {
  const {
    checkInDate,
    checkOutDate,
    childAges,
    packageGroupId,
    partyComp,
    rooms,
    searchFormId
  } = state.engine.engineStore

  return {
    action: state.engine.action,
    agent: state.engine.agent,
    checkInDate,
    checkOutDate,
    childAges,
    customerCode: state.engine.customerCode,
    isValidForSubmission: state.engine.isValidForSubmission,
    labelSubmit: _.get(state.engine.brandConfig, 'UITextDefaults.labelSubmit'),
    messages: state.engine.messages,
    operator: state.engine.operator,
    packageGroupId,
    partyComp,
    promotionCode: state.engine.promotionCode,
    roomBucket: state.engine.roomBucket,
    rooms,
    searchFormId,
    venueCode: state.engine.venueCode
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit: () => {
      return dispatch(engine.submit())
    },
    initializeEngine: () => {
      return dispatch(engine.initialize(ownProps.engineLogicOverrides))
    },
    toggle: (toggleType, forceVisible = false) => {
      return dispatch(engine.toggle(toggleType, forceVisible))
    },
    validate: (e) => {
      if (e && e.preventDefault) e.preventDefault()
      if (e && e.stopPropagation) e.stopPropagation()
      const fieldsToValidate = Object.assign({}, {
        checkInDate: true,
        checkOutDate: true,
        partyComp: true,
        rooms: true
      }, ownProps.fieldsToValidate)
      return dispatch(engine.validate(fieldsToValidate))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form)
